module.exports = __webpack_public_path__ + "img/glry-3.f82f0a7e.jpg";